import React, { useState } from 'react';
import {
  RiAddFill,
  RiBankLine,
  RiDeleteBinLine,
  RiEdit2Line,
  RiEditLine,
} from 'react-icons/ri';
import {
  Button,
  Chip,
  Divider,
  HelperText,
  IconButton,
  Modal,
} from '../../../../../components/UiComponents/Ui';
import { submitEditSupplierBankAccounts } from './setupActions';
import { useGlobalContext } from '../../../../../Contexts/GlobalContext';
import { getError } from '../../../../helperFunctions';
import SubmitButton from '../../../../../components/UiComponents/SubmitButton';
import AddBankAccountModal from '../../../../../components/UiComponents/AddBankAccountModal';
import { editSupplierBankInfoSchema } from './setupValidators';
import { formateZodError } from '../../../../../Utlils';
import { BankAccountCard } from '../../../../../components/UiComponents/InfoCards';

const EditSupplierBankInfo = ({
  supplierID,
  bankDetails,
  supplierDetailsMutate,
}) => {
  const [editBankingInfo, setEditBankingInfo] = useState(false);
  const [bankInfoData, setBankInfoData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const { setSnackbar } = useGlobalContext();

  const [singleBankDetailsModal, setSingleBankDetailsModal] = useState(false);
  const [editBankAccountModal, setEditBankAccountModal] = useState({
    open: false,
    index: 0,
  });
  const [bankData, setBankData] = useState({});

  const handleClose = () => {
    setBankInfoData({});
    setEditBankingInfo(false);
    setFormErrors({});
  };

  const handleBankCloseModal = () => {
    setSingleBankDetailsModal(false);
    setEditBankAccountModal({ open: false, index: 0 });
    setBankData({});
  };

  const handleDelete = (index) => {
    setBankInfoData((prev) => ({
      ...prev,
      bankAccounts: prev.bankAccounts?.filter((_, i) => i !== index),
    }));
  };

  const handleOpenEdit = (index, account) => {
    setBankData(account);
    setEditBankAccountModal({ open: true, index });
    setFormErrors({});
    setSingleBankDetailsModal(true);
  };

  const handleOpenAdd = () => {
    setBankData({});
    setEditBankAccountModal({ open: false, index: 0 });
    setFormErrors({});
    setSingleBankDetailsModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const validationResult = editSupplierBankInfoSchema.safeParse({
        ...bankInfoData,
        _id: supplierID,
      });

      if (validationResult.success) {
        const response = await submitEditSupplierBankAccounts({
          ...validationResult.data,
          _id: supplierID,
        });
        if (!response?.error) {
          setSnackbar({
            open: true,
            msg: 'Supplier Details updated successfully!',
            severity: 'success',
          })
          supplierDetailsMutate();
          handleClose();
        } else {
          setSnackbar({
            open: true,
            msg: 'Internal Server Error! Please try again!',
            severity: 'error',
          })
        }
      } else {
        setFormErrors(formateZodError(validationResult.error.errors));
      }
    } catch (error) {
      console.log('error in handleSubmit from edit Supplier info', error);
      setSnackbar({
        open: true,
        msg: 'Internal Server Error! Please try again!',
        severity: 'error',
      })
    }
  };

  const accountsError = getError(['bankAccounts'], formErrors);

  return (
    <div>
      <IconButton
        aria-label="Edit bank accounts"
        variant="ghost"
        onClick={() => {
          setEditBankingInfo(true);
          setBankInfoData({ bankAccounts: bankDetails });
        }}
      >
        <RiEditLine size={20} />
      </IconButton>

      <Modal
        showModal={editBankingInfo}
        setShowModal={handleClose}
        closeOnOutsideClick={false}
        width={600}
      >
        <form className="space-y-[18px]" onSubmit={handleSubmit}>
          <h2 className="text-lg font-semibold text-gray-800">
            View Bank Accounts
          </h2>
          <Divider />

          <div className="containerScroll max-h-[400px] space-y-2 overflow-y-auto pr-2">
            {bankInfoData?.bankAccounts?.length === 0 && (
              <div className="flex flex-col items-center justify-center gap-2 py-10 text-gray-400">
                <RiBankLine size={36} />
                <p className="text-sm">No bank accounts added yet</p>
              </div>
            )}

            {bankInfoData?.bankAccounts?.map((account, i) => (
              <BankAccountCard
                key={account._id || i}
                item={account }
                detailed
                alwaysShowActions
                onEdit={() => handleOpenEdit(i, account )}
                onRemove={() => handleDelete(i)}
              />
            ))}
          </div>

          {!!accountsError && typeof accountsError === 'string' && (
            <HelperText>{accountsError}</HelperText>
          )}

          <Button
            fullWidth
            variant="outlined"
            startIcon={<RiAddFill size={18} />}
            onClick={handleOpenAdd}
          >
            Add New Bank Account
          </Button>
          <Divider />
          <div className="flex items-center justify-end gap-2">
            <Button variant="outlined" intent="default" onClick={handleClose}>
              Cancel
            </Button>
            <SubmitButton name="Save Changes" />
          </div>
        </form>
      </Modal>

      <AddBankAccountModal
        showModal={singleBankDetailsModal}
        setShowModal={setSingleBankDetailsModal}
        handleCloseModal={handleBankCloseModal}
        modalData={bankData}
        setModalData={setBankData}
        setCustomerData={setBankInfoData}
        edit={editBankAccountModal.open}
        ediIndex={editBankAccountModal.index}
      />
    </div>
  );
};

export default EditSupplierBankInfo;
